import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './ProductSearchUGCResultsDetail.scss';
import { scrollTo } from 'ui/animation';

function scrollToDetail (sectionSelector) {

	const stickyHeader = document.querySelector('[data-stickyheader]');
	const sectionElem = document.querySelector(sectionSelector);
	if (sectionElem) {

		const stickyHeaderOffset = stickyHeader?.clientHeight ?? 0;
		const qaOffset = sectionElem.getBoundingClientRect().top;
		const y = qaOffset + window.pageYOffset - stickyHeaderOffset;
		scrollTo(200, y);

	}

}

const ProductSearchUGCResultsDetail = ({ type, component, qaInstance = false }) => {

	useEffect(() => {

		if (qaInstance) {

			scrollToDetail('.jsProductQuestionsAndAnswersContainer .ProductSearchUGCResults__header');

		} else {

			scrollToDetail('.jsTurnToReviewsContainer .ProductSearchUGCResults__header');

		}

	}, []);
	return (
		<div
			className={classNames('ProductSearchUGCResultsDetail', {
				[`ProductSearchUGCResultsDetail--${type}`]: Boolean(type)
			})}
		>
			{component}
		</div>
	);

};

ProductSearchUGCResultsDetail.propTypes = {
	component: PropTypes.element.isRequired,
	type: PropTypes.string,
	qaInstance: PropTypes.bool
};

export default ProductSearchUGCResultsDetail;
